import {SwaggerRepository} from "@/apps/portal-api/api/swagger";

export default {
    swagger: new SwaggerRepository(),
}